export default __webpack_public_path__ + "dist/media/Add.a1d534ae.svg";